import { Button, Modal, Switch } from "@deligoo/ui"
import localForage from "localforage"
import { memo, useState } from "react"
import { useTranslation } from "react-i18next"
import { shallowEqual, useDispatch } from "react-redux"

import { useAppSelector } from "@/App"
// import { setTeam } from "@/store/global"
import { selectCurrentTeam, selectTeams, selectTeamsStatus, setCurrentTeam } from "@/store/teams"
import { Team } from "@/types"
import { isProductionEnvironment, sessionForage } from "@/utils"

import cls from "./Header.module.scss"

export const SelectTeamModal = memo(({ handleClose }: { handleClose: () => void }) => {
  const teams = useAppSelector(selectTeams, shallowEqual)
  const teamsStatus = useAppSelector(selectTeamsStatus)
  const selectedTeam = useAppSelector(selectCurrentTeam, shallowEqual)

  const [areTestTeamsShown, showTestTeams] = useState(!isProductionEnvironment)

  const filteredTeams = areTestTeamsShown ? teams : teams.filter((team) => !team.is_test)

  const dispatch = useDispatch()
  const { t } = useTranslation()

  function selectTeam(team: Team) {
    dispatch(setCurrentTeam(team))

    localForage.setItem("team", team)
    sessionForage.setItem("team", team)

    handleClose()
  }

  return (
    <Modal handleClose={handleClose} loading={teamsStatus === "loading"} zIndex={1500} closeBtnPosition="inside">
      <Modal.Header>
        <Modal.Title>{t("select_teams")}:</Modal.Title>
        <Switch onClick={() => showTestTeams((areShown) => !areShown)} defaultChecked={areTestTeamsShown}>
          {t("show_test_teams")}
        </Switch>
      </Modal.Header>

      <Modal.Content>
        <div className={cls.teamsList}>
          {teamsStatus === "error" && t("error_loading_data")}
          {teamsStatus === "fetched" &&
            filteredTeams.map((team) => {
              const isSelected = selectedTeam?.uuid === team.uuid

              return (
                <Button
                  onClick={() => selectTeam(team)}
                  color={isSelected ? "primary" : undefined}
                  raised={isSelected}
                  variation="solid"
                  fullWidth
                  key={team.uuid}
                >
                  {team.name}
                </Button>
              )
            })}
        </div>
      </Modal.Content>
    </Modal>
  )
})
